<template>
  <div class="grid-table-wrapper">
    <!--Agents-->
    <ul
      class="grid-table grid-header"
      :class="{ 'grid-header-shadow': showOptions.headerShadow }"
    >
      <li class="grid-row">
        <span class="grid-column">Agent</span>
        <span class="grid-column">Role</span>
        <span class="grid-column">Translation language</span>
        <span class="grid-column">Access</span>
      </li>
    </ul>
    <ul class="grid-table grid-table-body" ref="table" @scroll="tableScroll">
      <li v-for="(agent, index) in agents" :key="index" class="grid-row">
        <div class="grid-column">
          <h3 class="name">{{ agent.name }}</h3>
          <span class="email">{{ agent.email }}</span>
        </div>

        <div class="grid-column">
          <span :class="`table-tag ${getTagColor(agent.role)}`">{{
            agent.role
          }}</span>
        </div>

        <div class="grid-column">
          <Dropdown
            :field="agent.languageField"
            :class="{ error: agent.languageField.hasError }"
            @fieldChanged="updateAgent(agent)"
          ></Dropdown>
        </div>

        <div class="grid-column">
          <span class="table-tag green">{{
            subscription.status === "trial" ? "Trial" : "Has Access"
          }}</span>
        </div>
      </li>
    </ul>

    <!--Agent Count-->
    <span class="grid-count"
      >Showing {{ agents.length }}
      {{ agents.length == 1 ? "agent" : "agents" }}</span
    >
  </div>
</template>

<script>
// Components
import Dropdown from "@/components/form/Dropdown";

export default {
  name: "AgentsTable",
  props: {
    agents: Array,
  },
  data() {
    return {
      showOptions: {
        headerShadow: false,
      },
    };
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    selectedApp() {
      return this.$store.getters.selectedApp;
    },
    subscription() {
      return this.selectedApp.subscription;
    },
  },
  components: { Dropdown },
  methods: {
    // Event on table scroll
    tableScroll() {
      const scrollTop = this.$refs.table.scrollTop;

      // Check if header needs shadow
      if (scrollTop > 0) this.showOptions.headerShadow = true;
      else this.showOptions.headerShadow = false;
    },

    // Tag color based on role
    getTagColor(role) {
      switch (role) {
        case "admin":
          return "zendesk";
        case "agent":
          return "";
        default:
          break;
      }
    },

    // Update agent
    updateAgent(agent) {
      this.$emit("updateAgent", agent);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";

.grid-column {
  &:nth-child(4) {
    text-align: center;
  }
}

.name {
  font-size: $smallFontSize;
  font-weight: $mediumFontWeight;
}

.email {
  font-size: $smallerFontSize;
  color: $greyColor;
}
</style>
